<div class="displayTable">
    <div class="displayTableCell" *ngIf="authService.userData != null">
      <h1>Bonjour {{authService.userData.displayName}}!</h1>
    </div>
    <div class="displayTableCell" *ngIf="authService.userData == null">
      <div class="authBlock">
        <h3>Authentification</h3>
        <div class="formGroup">
          <input type="text" class="formControl" placeholder="Nom d'utilisateur" #userName required>
        </div>
        <div class="formGroup">
          <input type="password" class="formControl" placeholder="Mot de passe" #userPassword required>
        </div>
        <!-- Calling SignIn Api from AuthService -->
        <div class="formGroup pt-3">
          <input type="button" class="btn btnPrimary" value="Se connecter" (click)="authService.SignIn(userName.value, userPassword.value)">
        </div>
        <div class="formGroup">
          <span class="or"><span class="orInner">Ou</span></span>
        </div>
        <!-- Calling GoogleAuth Api from AuthService -->
        <div class="formGroup">
          <button type="button" class="btn googleBtn" (click)="authService.GoogleAuth()">
            <i class="fab fa-google-plus-g"></i>
            Se connecter avec Google
          </button>
        </div>
        <div class="forgotPassword">
          <a routerLink="/forgot-password">Mot de passe oublié?</a>
        </div>
      </div>
      <div class="redirectToLogin">
        <span>Vous n'avez pas un compte? <a class="redirect" routerLink="/register-user">S'enregistrer</a></span>
      </div>
    </div>
  </div>
